// publications slider
let swiperPublications = null;

function initSwiperPublications() {
  if (window.innerWidth >= 768) { 
    if (!swiperPublications) {
      swiperPublications = new Swiper('.publications__slider', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        speed: 800,
        navigation: {
          nextEl: '.publications__slider-next',
          prevEl: '.publications__slider-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: 32,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    }
  } else {
    if (swiperPublications) {
      swiperPublications.destroy(true, true);
      swiperPublications = null;
    }
  }
}

initSwiperPublications();
window.addEventListener('resize', initSwiperPublications);
